import { motion } from 'framer-motion';
import { TestimonialCarousel } from '../components/TestimonialCarousel';

export default function TestimonialsPage() {
  return (
    <main className="pt-24 bg-white" data-testid="testimonials-page">
      {/* Hero Section */}
      <section className="py-16 lg:py-24 bg-neutral-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="accent-font text-lime-600 mb-4">Testimonials</p>
            <h1 className="font-outfit font-bold text-4xl sm:text-5xl lg:text-6xl text-neutral-900 tracking-tight mb-6">
              What Our <span className="text-lime-600">Customers</span> Say
            </h1>
            <p className="text-neutral-600 text-lg max-w-3xl">
              Don&apos;t just take our word for it. Here&apos;s what our clients have to say 
              about working with North Somerset Environment Company.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <TestimonialCarousel showAll={true} />
    </main>
  );
}
